/**
 * ConfigErrorScreen — rendered when required Entra configuration variables are
 * missing (task 3.12; Req 2.6). Shows a centered card listing the missing
 * environment variables, using the same auth-screen design-system styling.
 *
 * This guard sits OUTSIDE the `EntraAuthProvider` since the provider requires
 * a valid config to initialize.
 */

export interface ConfigErrorScreenProps {
  /** List of missing environment variable names. */
  missing: string[];
}

/**
 * Configuration-error screen displayed when `readMsalConfig` returns
 * `ok: false`. The auth provider is NOT rendered in this case (no attempt to
 * initialize MSAL), and no data fetch is ever issued.
 */
export default function ConfigErrorScreen({ missing }: ConfigErrorScreenProps) {
  return (
    <div className="auth-screen" role="main" aria-label="Configuration error">
      <div className="auth-card auth-card--config-error">
        <h1 className="auth-card__title">Configuration Error</h1>
        <p className="auth-card__message">
          The dashboard cannot start because required authentication
          configuration is missing. Please contact your administrator.
        </p>
        <ul className="auth-card__error-list">
          {missing.map((varName) => (
            <li key={varName}>
              <code>{varName}</code>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
